import {NgModule} from '@angular/core';
import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {AuthRoutingModule} from '@modules/auth/auth.routing';
import {SharedModule} from '@shared/shared.module';
import {NgxsModule} from '@ngxs/store';
import {AuthState} from '@shared/state/auth/auth.state';
import {AuthGuard} from '@app/guard/auth.guard';
import {NzAlertModule} from 'ng-zorro-antd/alert';
import {NoAuthGuard} from '@app/guard/no-auth.guard';
import {NzDividerModule} from 'ng-zorro-antd/divider';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [LoginComponent, RegisterComponent, ForgotPasswordComponent],
  imports: [
    SharedModule,
    NgxsModule.forFeature([AuthState]),
    NzAlertModule,
    AuthRoutingModule,
    NzDividerModule,
    FontAwesomeModule
  ],
  providers: [AuthGuard, NoAuthGuard]
})
export class AuthModule {
}
